import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
//redux
import { useDispatch, useSelector } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import FilterLayout from "./filter"
import moment from "moment"
import { setIsMobile } from "store/actions"
import TableContainer from "./table"
import { getTeamLookup } from "store/createTeam/action"
import { StartTime } from "pages/Reports/VerifyScreens/VerifyScreenCol"
import { getHoursReport } from "store/Teams/action"
import { StartDateactivity } from "pages/Reports/VerifyMyTeams/VerifyScreenCol"

const HoursReport = () => {
  document.title = "Hours Report | TenderSoftware - Flexi TracBoard"
  const [hoursReportList, setHoursReportList] = useState([])
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const fromDate = moment(new Date(startDate)).format("YYYY-MM-DD")
  const toDate = moment(new Date(endDate)).format("YYYY-MM-DD")
  const [activeReportStatus, setActiveReportStatus] = useState({
    id: 1,
    label: "Daily Employee hours",
    value: "Daily Employee hours",
  })
  const [pageSize, setpageSize] = useState(10)
  const [pageindex, setpageindex] = useState(0)
  const [selectedclientId, setSelectedclientId] = useState({})
  const [selectedprojectId, setSelectedprojectId] = useState({})
  const [filtersubCategory, setfiltersubCategory] = useState([])
  const [activeName, setactiveName] = useState("ALL")
  const [sort, setSort] = useState({
    direction: "asc",
    accessor: "user_name",
  })
  const [billableType, setBilliableType] = useState({
    id: 0,
    label: "All",
    value: "All",
  })
  
  const dispatch = useDispatch()

  useEffect(() => {
    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 921))
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    dispatch(getTeamLookup())
  }, [])

  const { isMobile, companySetting, teamList, hoursReportsData, getallbillingtypes } = useSelector(
    state => ({
      isMobile: state?.teams?.isMobile,
      companySetting: state?.Login?.userDetails?.data,
      teamList: state?.createteam?.createTeamLookupList,
      emplList: state?.userlist?.userlist?.data,
      hoursReportsData: state?.teams?.hourReportSuccessList,
      getallbillingtypes:
      state?.createteam?.createTeamLookupList?.billingTypeLookup,
    })
  )
  
  useEffect(() => {
    const reportsX = (hoursReportsData?.datas || [])?.map(el => {
      return {
        ...el,
        date: el.date,
      }
    })
    setHoursReportList(reportsX)
  }, [hoursReportsData])

  // server side header click sorting
  const columnHeaderClick = (column, pagesize, pageIndex) => {
    switch (column.sortDirection) {
      case "none":
        setSort({ direction: "asc", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          sortKey: column.id,
          sortValue: "asc",
        })
        break
      case "asc":
        setSort({ direction: "desc", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          sortKey: column.id,
          sortValue: "desc",
        })
        break
      case "desc":
        setSort({ direction: "asc", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          sortKey: column.id,
          sortValue: "asc",
        })
        break
    }
  }
  // view billable type concept
  const handlebillableFilter = data => {
    setBilliableType(data)
  }
  // table columns
  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "Date",
        accessor: "date",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id !== 1 && true,
        sortDirection: sort.accessor === "date" ? sort.direction : "none",
        Cell: cellProps => {
          return <StartDateactivity {...cellProps} />
        },
        footerType: false,
        totalType: false,
        width: !isMobile && 100,
      },
      {
        Header: "Employee Id",
        accessor: "empId",
        disableFilters: true,
        sort: true,
        hidden: false,
        sortDirection: sort.accessor === "empId" ? sort.direction : "none",
        footerType: false,
        totalType: false,
        width: isMobile ? "" : activeReportStatus?.id === 1 ? 80 : 130,
      },
      {
        Header: "Name",
        accessor: "user_name",
        disableFilters: true,
        sort: true,
        hidden: false,
        sortDirection: sort.accessor === "user_name" ? sort.direction : "none",
        Footer: info => (
          <>
            {activeReportStatus?.id == 2 ||
              (activeReportStatus?.id == 3 && (
                <strong className="d-flex justify-content-end">Total: </strong>
              ))}
          </>
        ),
        footerType: true,
        totalType: true,
        width: isMobile ? "" : activeReportStatus?.id !== 4 ? 280 : 180,
      },
      {
        Header: "Project Name",
        accessor: "projectname",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id == 4 ? false : true,
        sortDirection:
          sort.accessor === "projectname" ? sort.direction : "none",
        footerType: false,
        width: isMobile && "",
      },
      {
        Header: "Project Head",
        accessor: "headName",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id == 4 ? false : true,
        sortDirection: sort.accessor === "headName" ? sort.direction : "none",
        Footer: info => (
          <>
            {activeReportStatus?.id == 4 && (
              <strong className="d-flex justify-content-end">Total: </strong>
            )}
          </>
        ),
        footerType: true,
        totalType: true,
        width: isMobile && "",
      },
      {
        Header: "Start Time",
        accessor: "startTime",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id !== 1 && true,
        sortDirection: sort.accessor === "startTime" ? sort.direction : "none",
        Cell: cellProps => {
          return <StartTime {...cellProps} />
        },
        footerType: false,
        totalType: false,
        width: !isMobile && 80,
      },
      {
        Header: "End Time",
        accessor: "endTime",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id !== 1 && true,
        sortDirection: sort.accessor === "endTime" ? sort.direction : "none",
        Cell: cellProps => {
          return <StartTime {...cellProps} />
        },
        Footer: info => (
          <>
            <strong className="d-flex justify-content-end">Total: </strong>
          </>
        ),
        footerType: true,
        totalType: true,
        width: isMobile && "",
      },
      {
        Header: "Total Hours",
        accessor: "totalHours",
        disableFilters: true,
        sort: true,
        hidden: false,
        sortDirection: sort.accessor === "totalHours" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start text-primary">
              {sumofIdleHours("totalHours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
        width: isMobile ? "" : activeReportStatus?.id == 4 && 100,
      },
      {
        Header: "Billable Hours",
        accessor: "clientHours",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id !== 4 ? false : true,
        sortDirection:
          sort.accessor === "clientHours" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start">
              {sumofIdleHours("clientHours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
        width: isMobile && "",
      },
      {
        Header: "Non-Billable Hours",
        accessor: "internalHours",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id !== 4 ? false : true,
        sortDirection:
          sort.accessor === "internalHours" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start">
              {sumofIdleHours("internalHours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
        width: isMobile && "",
      },
      {
        Header: "Leave Hours",
        accessor: "leavehours",
        style: { textAlign: "center" },
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id !== 4 ? false : true,
        sortDirection: sort.accessor === "leavehours" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start">
              {sumofIdleHours("leavehours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
        width: isMobile && "",
      },
      {
        Header: "Total Hours Decimal",
        accessor:
          activeReportStatus?.id == 4 ? "totalInDecimal" : "totalHoursDecimal",
        disableFilters: true,
        sort: true,
        hidden: false,
        sortDirection:
          (sort.accessor === activeReportStatus?.id) == 4
            ? "totalInDecimal"
            : "totalHoursDecimal"
            ? sort.direction
            : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start font-weight-bold">
              {sumofDecimalValue(
                activeReportStatus?.id == 4
                  ? "totalInDecimal"
                  : "totalHoursDecimal",
                hoursReportList
              )}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
        width: isMobile ? "" : activeReportStatus?.id == 4 && 100,
      },
      {
        Header: "Reporting Lead",
        accessor: "reportingLead",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id == 4 ? false : true,
        sortDirection:
          sort.accessor === "reportingLead" ? sort.direction : "none",
        width: isMobile && "",
      },
      {
        Header: "Supervisor",
        accessor: "supervisor",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id == 4 ? false : true,
        sortDirection: sort.accessor === "supervisor" ? sort.direction : "none",
        width: isMobile && "",
      },
      {
        Header: "Client Hours Decimal",
        accessor: "clientHoursDecimal",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id !== 4 ? false : true,
        sortDirection:
          sort.accessor === "clientHoursDecimal" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start font-weight-bold">
              {sumofDecimalValue("clientHoursDecimal", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
        width: isMobile && "",
      },
      {
        Header: "Internal Hours Decimal",
        accessor: "internalHoursDecimal",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus?.id !== 4 ? false : true,
        sortDirection:
          sort.accessor === "internalHoursDecimal" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start font-weight-bold">
              {sumofDecimalValue("internalHoursDecimal", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
        width: isMobile && "",
      },
      {
        Header: "Leave Hours Decimal",
        accessor: "leavehoursDecimal",
        disableFilters: true,
        sort: true,
        hidden: isMobile ? "" : activeReportStatus?.id !== 4 ? false : true,
        sortDirection:
          sort.accessor === "leavehoursDecimal" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start font-weight-bold">
              {sumofDecimalValue("leavehoursDecimal", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: true,
        width: isMobile && "",
      },
    ]
    return result
  }, [activeReportStatus, sort, hoursReportList, isMobile])

  const handleSubmit = e => {
    e.preventDefault()
    onHandleFilterBtnClicked()
  }

  const onHandleFilterBtnClicked = () => {
    loadHoursReportScreen()
  }

  const loadHoursReportScreen = () => {
    const hoursreport = {
      empId: activeName?.label == "All" ? "" : activeName?.value,
      fromDate: fromDate,
      toDate: toDate,
      client:
        selectedclientId?.label == "All" || selectedclientId == null
          ? ""
          : selectedclientId?.id,
      project:
        selectedprojectId?.label == "All" || selectedprojectId == null
          ? ""
          : selectedprojectId?.id,
      reportType: activeReportStatus?.id,
      billingType:
      billableType?.label == "All" || billableType == null
        ? ""
        : billableType?.id,
      export: false,
      sortKey: sort?.accessor,
      sortValue: sort?.direction,
      pageSize: pageSize,
      pageNumber:
        activeName?.label !== "All" ||
        selectedclientId?.label !== "All" ||
        selectedclientId !== null ||
        selectedprojectId?.label !== "All" ||
        selectedprojectId !== null || billableType?.label !== "All" ||
        billableType !== null
          ? 1
          : pageindex + 1,
    }
    dispatch(getHoursReport(hoursreport))
  }

  useEffect(() => {
    loadHoursReportScreen()
    if (
      activeName?.label !== "All" ||
      selectedclientId?.label !== "All" ||
      selectedclientId !== null ||
      selectedprojectId?.label !== "All" ||
      selectedprojectId !== null || billableType?.label !== 'All' || billableType !== null
    ) {
      setpageindex(0)
    }
  }, [activeReportStatus, selectedprojectId, selectedclientId, activeName, billableType ])

  const handleReportFilter = data => {
    setActiveReportStatus(data)
  }
  // custom pagination page value and
  const handlePageValue = value => {
    if (!value.noChange) setpageindex(value.pageNumber)
    setpageSize(value.pageSize)
    dispatch(
      getHoursReport({
        ...value,
        pageNumber: value.pageNumber + 1,
        sortKey: value.sortKey ? value.sortKey : sort?.accessor,
        sortValue: value.sortValue ? value.sortValue : sort?.direction,
        empId: activeName?.label == "All" ? "" : activeName?.value,
        fromDate: fromDate,
        toDate: toDate,
        client: selectedclientId?.label == "All" ? "" : selectedclientId?.id,
        project: selectedprojectId?.label == "All" ? "" : selectedprojectId?.id,
        billingType: billableType?.label == 'All' || billableType == null ? '' : billableType?.id,
        reportType: activeReportStatus?.id,
        export: false,
        pageSize: value?.pageSize,
      })
    )
  }

  // get report summary
  const GetHourSummaryReport = e => {
    e.preventDefault()
    const hoursreportdownload = {
      empId: activeName?.label == "All" ? "" : activeName?.value,
      fromDate: fromDate,
      toDate: toDate,
      client: selectedclientId?.label == "All" ? "" : selectedclientId?.id,
      project: selectedprojectId?.label == "All" ? "" : selectedprojectId?.id,
      reportType: activeReportStatus?.id,
      billingType: billableType?.label == 'All' ? '' : billableType?.id,
      export: true,
    }
    dispatch(
      getHoursReport(
        hoursreportdownload,
        "export",
        activeReportStatus?.label.toLowerCase().replace(/\s/g, "_")
      )
    )
  }

  // maincategory to subcategory filter in useeffect
  useEffect(() => {
    setfiltersubCategory(teamList?.subCategoryLookup)
  }, [teamList])

  // employee name
  const handleNameFilter = value => {
    setactiveName(value || "ALL")
  }
  const padZero = value => {
    return value > 9 ? value : `0${value}`
  }
  // Adding private, idle, break hours
  const sumofIdleHours = (key, arr, returnValue) => {
    if (arr.length <= 0) return <></>

    const timesarr = []
    ;(arr || []).map((item, index) => {
      timesarr.push(item[key])
    })
    const sum = timesarr?.reduce(
      (acc, time) => acc.add(moment.duration(time)),
      moment.duration()
    )
    if (returnValue)
      return [
        padZero(Math.floor(sum.asHours())),
        padZero(sum.minutes()),
        padZero(sum.seconds()),
      ].join(":")
    return (
      <>
        <strong>
          {[
            padZero(Math.floor(sum.asHours())),
            padZero(sum.minutes()),
            padZero(sum.seconds()),
          ].join(":")}
        </strong>
      </>
    )
  }
  const sumofDecimalValue = (key, arr, returnValue) => {
    if (arr.length <= 0) return <></>
    const decimalarr = []
    ;(arr || []).map((item, index) => {
      decimalarr.push(item[key])
    })
    const sum = decimalarr.reduce((acc, value) => acc + value, 0)
    const aroundNumber = Math.floor(sum * 100) / 100
    if (!returnValue) {
      return aroundNumber // Return the sum if returnValue is true
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title={"Hours Report"} breadcrumbItem={"Hours Report"} />
          <Card>
            <CardBody>
              <FilterLayout
                setStartDate={setStartDate}
                startDate={startDate}
                setEndDate={setEndDate}
                endDate={endDate}
                handleReportFilter={handleReportFilter}
                handleSubmit={handleSubmit}
                activeReportStatus={activeReportStatus}
                GetHourSummaryReport={GetHourSummaryReport}
                companySetting={companySetting}
                MainCategory={teamList?.categoryLookup}
                teams={teamList?.subCategoryLookup}
                setSelectedclientId={setSelectedclientId}
                setSelectedprojectId={setSelectedprojectId}
                SubCategory={filtersubCategory}
                handleNameDropdownFilter={handleNameFilter}
                isV0
                handlebillableFilter={handlebillableFilter}
                getallbillingtypes={getallbillingtypes}
                billableType={billableType}
              />
              <Row>
                <Col xs="12">
                  <div className="p-0 table-mobileView">
                    <>
                      <TableContainer
                        keyField="empId"
                        columns={columns}
                        data={hoursReportList}
                        isMobile={isMobile}
                        customPageSize={10}
                        totalCount={hoursReportsData?.count || 0}
                        pageindex={pageindex}
                        setpageindex={setpageindex}
                        handlePageValue={handlePageValue}
                        onHeaderClick={columnHeaderClick}
                        customPageSizeOptions
                        className="custom-header-css"
                        activeReportStatus={activeReportStatus}
                        noPagination
                      />
                    </>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

HoursReport.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default HoursReport
